import { useGetBrokerGroupQuery } from '@/admin/brokerGroups/api/brokerGroupsApi';
import { useListInsightFieldsQuery } from '@/admin/api/insightFieldsApi';

/**
 * An Insight id by its name in the primary broker group's ledger's list (listInsightFields),
 * or the id as written until the list loads, or if it isn't in it.
 */
export const InsightIdCell = ({ brokerGroupId, fieldType, value }) => {
	// currentData, not data: after the primary changes, data is still the old broker group's
	// and the old ledger's list until the new ones load (or for good, if the new list fails)
	const { currentData: brokerGroup } = useGetBrokerGroupQuery(brokerGroupId, {
		skip: !brokerGroupId,
	});
	const { currentData: options = [] } = useListInsightFieldsQuery(
		{ ledger: brokerGroup?.ledger, fieldType },
		{ skip: !brokerGroup?.ledger || value == null },
	);
	return options.find(({ id }) => id === Number(value))?.name ?? value;
};
